import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject } from 'rxjs';
import { RootService } from '../../../../shared/services/root.service';
import { SessionService } from '@core/services-v2/session/session.service';
import { GeolocationServiceV2 } from '@core/services-v2/geolocation/geolocation.service';
import { CustomerService } from '@core/services-v2/customer.service';
import { IArticlePrice } from '@core/models-v2/customer/customer.interface';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';
import { TableLazyLoadEvent } from 'primeng/table';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-page-lista-precios',
  templateUrl: './page-lista-precios.component.html',
  styleUrls: ['./page-lista-precios.component.scss'],
  providers: [MessageService],
})
export class PageListaPreciosComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  datatableElement!: DataTableDirective;
  innerWidth!: number;
  precios!: IArticlePrice[];
  loadingData = true;
  showTaxes: boolean = true;
  categoria: string = '';

  dtOptions: DataTables.Settings = {};

  // showLoading = true;
  showLoading = false;
  taxConfig = environment.tax;
  totalRows: number = 0;
  rows: number = 10;
  first: number = 0;
  isMobile: boolean = false;
  searchValue: string = '';

  private localizacion$: Subject<any> = new Subject();
  readonly localizacionObs$: Observable<any> =
    this.localizacion$.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public root: RootService,
    private readonly sessionService: SessionService,
    private readonly geolocationService: GeolocationServiceV2,
    private readonly customerService: CustomerService,
    private readonly messageService: MessageService
  ) {
    // cambio de sucursal
    this.geolocationService.selectedStore$.subscribe({
      next: () => {
        this.buscarPrecios();
      },
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) this.checkScreenSize();
    this.buscarPrecios();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (isPlatformBrowser(this.platformId)) this.checkScreenSize();
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 800;
  }

  /**
   * Obtener precios usuario
   * @param event
   */
  buscarPrecios(event?: TableLazyLoadEvent): void {
    const tiendaSeleccionada = this.geolocationService.getSelectedStore();
    const user = this.sessionService.getSession();
    this.first = event?.first || 0;
    this.rows = event?.rows || this.rows;
    // this.showLoading = true;
    this.loadingData = true;

    this.customerService
      .getCustomerPriceList(user.documentId, {
        page: this.first / this.rows + 1,
        branchCode: tiendaSeleccionada.code,
        limit: this.rows,
        search: this.searchValue,
        urlCategory: this.categoria,
      })
      .subscribe({
        next: async (res) => {
          this.precios = res.data;
          this.precios = await Promise.all(
            this.precios.map((p) => {
              if (p.price > p.commonPrice) p.price = p.commonPrice;
              p.priceBruto = Math.round(p.price / (1 + this.taxConfig.value));
              p.commonPriceBruto = Math.round(
                p.commonPrice / (1 + this.taxConfig.value)
              );
              return { ...p };
            })
          );
          this.totalRows = res.total;
          // this.showLoading = false;
          this.loadingData = false;
        },
        error: (err) => {
          console.log(err);
          this.messageService.add({
            severity: 'error',
            summary: 'No se pueden obtener los vehículos',
            detail: 'Ha ocurrido un error al obtener los vehículos.',
          });
        },
      });
  }

  busqueda(event?: any) {
    if (event) this.searchValue = event.target.value || '';
    else this.searchValue = '';
    this.buscarPrecios();
  }

  // busquedaCategoria(event: any): void {
  //   this.categoria = event;
  //   this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) =>
  //     dtInstance.draw()
  //   );
  // }
}
